unable to read source [project]/node_modules/posthog-js/react/src/hooks/useFeatureFlagPayload.ts